import { useInjection } from 'inversify-react';
import { useEffect } from 'react';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import type { IAnalyticsService } from '../../services/analytics/analytics.service.interface';
import { useConsent } from '../consent/use-consent';

export function useAnalyticsConsentSync() {
  const analytics = useInjection<IAnalyticsService>(AnalyticsService);
  const { consents } = useConsent();

  useEffect(() => {
    analytics.applyConsents(consents);
  }, [analytics, consents]);
}
